import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 22V6L18.4649 6C18.8052 5.41165 19 4.72857 19 4C19 1.79086 17.2091 -9.65645e-08 15 0C13.8053 5.22217e-08 12.7329 0.523756 12 1.35418C11.2671 0.523756 10.1947 2.10047e-07 9 2.62269e-07C6.79086 3.58834e-07 5 1.79086 5 4C5 4.72858 5.19479 5.41165 5.53513 6H1L1 22H23ZM13 4C13 2.89543 13.8954 2 15 2C16.1046 2 17 2.89543 17 4C17 5.10457 16.1046 6 15 6C13.8954 6 13 5.10457 13 4ZM14.4142 8L21 8V14H3L3 8L9.58579 8L6.58579 11L8 12.4142L12 8.41421L16 12.4142L17.4142 11L14.4142 8ZM11 4C11 5.10457 10.1046 6 9 6C7.89543 6 7 5.10457 7 4C7 2.89543 7.89543 2 9 2C10.1046 2 11 2.89543 11 4Z"}}]};

const GiftFilled = Vue.extend<IconProps>({
  name: 'GiftFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'gift-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GiftFilled;
